module.exports = "/_next/static/images/8829bd63f57312ac764d819b093e50b7-pj-woman-working@0.5x.jpg.webp";